import {ParserConfig} from "../../../api/config";
import React, {useEffect, useState} from "react";
import Editor from "@monaco-editor/react";
import {Button} from "antd";
import * as monaco from "monaco-editor";

interface JsonConfigEditorProps {
    config: ParserConfig | null
    onApplyDraftConfig: () => void;
    onDraftConfigChange?: (draft: ParserConfig) => void;
}

export function TextConfigEditor({config, onApplyDraftConfig, onDraftConfigChange}: JsonConfigEditorProps) {
    const [monaco, setMonaco] = useState<monaco.editor.IStandaloneCodeEditor | null>(null);

    const setNewConfig = () => {
        if (!monaco || !onApplyDraftConfig) {
            return
        }

        onApplyDraftConfig();
    }

    useEffect(() => {
        if (monaco && config) {
            monaco.setValue(JSON.stringify(config, null, 2))
        }
    }, [config, monaco])

    return (
        <>
            <Editor
                height="92%"
                defaultLanguage="json"
                onMount={(editor) => setMonaco(editor)}
                options={{
                    minimap: {
                        enabled: false
                    },
                    lineNumbers: "off",
                    scrollBeyondLastLine: false,
                    // readOnly: true,
                    // domReadOnly: true
                }}
                onChange={() => onDraftConfigChange && onDraftConfigChange(JSON.parse(monaco!.getValue()))}
            />

            <Button className="apply-config" type={"primary"}
                    onClick={setNewConfig}>Применить JSON</Button>
        </>
    )
}
